export default __webpack_public_path__ + "static/media/codequiz.528066fe.png";